import React from 'react'
import { localStorageApi } from '../localStorageApi'

const PAGE_REFRESHED_KEY = 'page-has-been-force-refreshed'

export const lazyWithRetry = (componentImport, options) => {
	return React.lazy(() => {
		const pageHasAlreadyBeenForceRefreshed =
			JSON.parse(localStorageApi.getItem(PAGE_REFRESHED_KEY) || 'false')
		let component = () => (options?.fallback || <div>Loading...</div>)
		try {
			component = componentImport()
			localStorageApi.setItem(PAGE_REFRESHED_KEY, 'false')
		} catch (error) {
			if (!pageHasAlreadyBeenForceRefreshed) {
				localStorageApi.setItem(PAGE_REFRESHED_KEY, 'true')
				window.location.reload()
				return component
			}
			throw error
		}
		return component
	})
}
